import { initInsetMap } from '../map/insetMapManager.js';

export function setupInsetMap(map, config) {
  if (!config.inset || config.legend) {
    return null;
  }

  return initInsetMap(map, config);
}
